import CreditProgress from '@/components/credit-progress';
import Product from '@/components/product';
import Title from '@/components/title';
import { isAuthenticated } from '@/lib/api';
import { createFileRoute, Link, redirect } from '@tanstack/react-router';
import ChallengeProgress from '@/components/challenge-progress';
import AuthLayout from '@/components/auth-layout';
import { useProducts } from '@/hooks/useProducts';

export const Route = createFileRoute('/')({
  beforeLoad: async ({ location }) => {
    if (!isAuthenticated()) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      });
    }
  },
  component: Home,
});

function Home() {
  const { products, groupedProducts, isSpecialUser, isLoading } = useProducts();

  return (
    <div className="">
      <AuthLayout>
        <section className="px-4 md:px-0 py-24">
          <div className="container mx-auto flex flex-col text-center">
            <Title text="Aktuális küldetések" />
            <p className="text-2xl mb-6">
              Minden teljesített küldetés közelebb visz a jutalmadhoz. Gyűjts
              krediteket, és váltsd be őket élményekre, ajándékokra.
            </p>
            <div className="w-full mb-6">
              <ChallengeProgress />
            </div>
            <div className="w-full">
              <div className="max-w-2xl mx-auto py-[10px]">
                <Link
                  to="/challenges"
                  className="bg-heineken-green text-white font-bold w-full px-4 py-3 cursor-pointer"
                >
                  Tovább a részletekre
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section className="px-4 md:px-0 py-24">
          <div className="container mx-auto flex flex-col text-center">
            <Title text="Aktuális kreditállás" />
            <p className="text-2xl mb-6">
              Fontos tudnod, hogy a promóció egy "nagy közös pénztárcán" alapul,
              amely minden résztvevő partner számára elérhető. Ennek tartalma,
              vagyis a promóció alatt elérhető total kreditek mennyisége
              korlátozott – ezért érdemes figyelemmel kísérned az aktuális
              állást, hisz ha kiürül a kassza, a promóció is véget ér.
            </p>

            <p className="font-bold text-2xl mb-6">
              Siess! A promóciós kreditek gyorsan fogynak!
            </p>
            <div className="w-full">
              <CreditProgress />
            </div>
          </div>
        </section>

        <section id="products" className="px-4 md:px-0 pb-10">
          <div className="container mx-auto">
            <div className="flex flex-col">
              <Title text="Választható ajándékok" />
              <p className="font-bold">
                Lepd meg magad, motiváld kollégáidat, vagy élvezd a pihenést egy
                wellness hétvégén a pároddal.
              </p>
              <p className="mb-10">
                Böngéssz a folyamatosan elérhető ajándékok között, vagy csapj le
                a limitált, exkluzív meglepetésekre – amíg a készlet tart!
              </p>
            </div>

            {isLoading ? (
              <div className="col-span-full text-center py-8">
                <p className="text-lg">Termékek betöltése...</p>
              </div>
            ) : isSpecialUser ? (
              groupedProducts.length > 0 ? (
                groupedProducts
                  .filter((group) => group.promotion)
                  .map((group) => (
                    <div key={group.promotion!.id} className="mb-12">
                      <h2
                        className="text-2xl font-bold mb-4"
                        tabIndex={0}
                        aria-label={`Promóció: ${group.promotion!.label || group.promotion!.name}`}
                      >
                        {group.promotion!.name}
                      </h2>
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                        {group.products.map((product) => (
                          <Product key={product.id} product={product} />
                        ))}
                      </div>
                    </div>
                  ))
              ) : (
                <div className="col-span-full text-center py-8">
                  <p className="text-lg">
                    Jelenleg nincsenek elérhető termékek.
                  </p>
                </div>
              )
            ) : products.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                {products.map((product) => (
                  <Product key={product.id} product={product} />
                ))}
              </div>
            ) : (
              <div className="col-span-full text-center py-8">
                <p className="text-lg">Jelenleg nincsenek elérhető termékek.</p>
              </div>
            )}

            <div className="flex flex-col">
              <p className="mt-10 text-right text-xs">A képek illusztrációk.</p>
            </div>
          </div>
        </section>
      </AuthLayout>
    </div>
  );
}

export default Home;
